import { createSlice } from "@reduxjs/toolkit";

const issuesPinDataSlice = createSlice({
  name: "issuesPinData",
  initialState: {},
  reducers: {
    setIssuesPinData: (_state, action) =>
      action.payload.reduce((prev, curr) => {
        if (curr && curr.id) {
          return { ...prev, [curr.id]: curr };
        }
        return prev;
      }, {}),
    mergeIssuesPinData: (state, action) => {
      state[action.payload.id] = { ...action.payload };
    },
    deleteIssuesPinData: (state, action) => {
      action.payload.forEach((issue) => {
        delete state[issue];
      });
    },
  },
});

export const { setIssuesPinData, mergeIssuesPinData, deleteIssuesPinData } = issuesPinDataSlice.actions;
export default issuesPinDataSlice.reducer;
